import { use } from 'react';
import { OrderDetailClient } from './order-detail-client';

export const metadata = { title: 'Order · Admin' };

export default function Page({ params }: { params: Promise<{ id: string }> }) {
  const { id } = use(params);
  return <OrderDetailClient orderId={id} />;
}
